<template>
  <div>
    <div class="modal fade" id="register-delivery-info-modal" role="dialog" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog modal-lg" @click.stop>
        <div class="modal-content">
          <div class="modal-body">
            <h4 class="m-t-none m-b-none"><strong>お届け先情報</strong></h4>
            <div class="form-register p-xl">
              <form>
                <div class="form-group">
                  <label for="name">お届け先名（企業名、氏名など）</label><span class="label-required">必須</span><span class="mr-l-5">全角16文字以内</span>
                  <input type="text" v-model.trim="formRegisterData.name" class="form-control" id="name">
                  <div v-if="validateErrors.name" class="text-red"><b>{{ validateErrors.name }}</b></div>
                </div>
                <div class="form-group">
                  <label for="postalcode">郵便番号</label><span class="label-required">必須</span>
                  <div class="row">
                    <div class="col-md-6">
                      <input type="text" v-model.trim="formRegisterData.postalCode" @input="formRegisterData.postalCode = handleInputPostalCode(formRegisterData.postalCode)" class="form-control" id="postalcode" placeholder="ハイフンなし">
                    </div>
                    <div class="col-md-6">
                      <button type="button" class="btn btn-primary custom-btn-delivery check-maintenance" @click.prevent="searchAddressByPostalCode()">住所検索</button>
                    </div>
                  </div>
                  <div v-if="validateErrors.postalCode" class="text-red"><b>{{ validateErrors.postalCode }}</b></div>
                </div>
                <div class="form-group">
                  <label for="address">住所1</label><span class="label-required">必須</span>
                  <div class="box-input-address">
                    <input type="text" v-model.trim="formRegisterData.address1" class="form-control" id="address" autocomplete="off" @input="handleChangeAddress()" @focus="handleFocusAddress()" @blur="handleBlurAddress()">
                    <div v-if="showAddressList" class="box-address-list">
                      <ul class="address-list list-group">
                        <a v-for="(address, addressIndex) in addressList" :key="addressIndex" href="javascript:void(0)" :class="['address-item list-group-item list-group-item-action', formRegisterData.address1 === address ? 'active' : '']" @click.prevent="chooseAddressItem(address)">{{ address }}</a>
                      </ul>
                    </div>
                  </div>
                  <div>※住所検索時は続きをご入力ください</div>
                  <div v-if="validateErrors.address1" class="text-red"><b>{{ validateErrors.address1 }}</b></div>
                </div>
                <div class="form-group">
                  <label for="address">住所2（住所1のつづき）</label><span class="label-any">任意</span>
                  <div class="box-input-address">
                    <input type="text" v-model.trim="formRegisterData.address2" class="form-control" id="address" autocomplete="off" @input="handleChangeAddress()" @focus="handleFocusAddress()" @blur="handleBlurAddress()">
                  </div>
                  <div v-if="validateErrors.address2" class="text-red"><b>{{ validateErrors.address2 }}</b></div>
                </div>
                <div class="form-group">
                  <label for="phone-number">電話番号</label><span class="label-required">必須</span>
                  <input type="text" v-model.trim="formRegisterData.phoneNo" class="form-control" @input="formRegisterData.phoneNo = handleInputPhoneNo(formRegisterData.phoneNo)" id="phone-number">
                  <div v-if="validateErrors.phoneNo" class="text-red"><b>{{ validateErrors.phoneNo }}</b></div>
                </div>
                <div class="text-center m-t-lg">
                  <button type="button" class="btn btn-basic custom-btn-delivery m-r-sm" data-dismiss="modal" @click="$emit('close')">閉じる</button>
                  <button type="button" class="btn btn-warning custom-btn-delivery check-maintenance" :disabled="disabledSubmit" @click.prevent="handleSubmit()">登録する</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DeliveryInfoSellerService from '@/services/deliveryinfosellerservice'

export default {
  data () {
    return {
      loader: null,
      formRegisterData: {
        name: '',
        postalCode: '',
        address1: '',
        address2: '',
        phoneNo: ''
      },
      showAddressList: false,
      addressList: [],
      validateErrors: {
        name: '',
        postalCode: '',
        address1: '',
        address2: '',
        phoneNo: ''
      }
    }
  },
  props: {
    deliveryInfo: {
      type: Object,
      default: null
    }
  },
  computed: {
    disabledSubmit () {
      return false
      // const limitByteSizeName = 48
      // return !(this.formRegisterData.name && this.getByteSize(this.formRegisterData.name) <= limitByteSizeName && this.formRegisterData.postalCode && this.formRegisterData.address1 && this.formRegisterData.phoneNo && this.isInValidPhoneNumber)
    }
  },
  methods: {
    handleChangeAddress () {
      if (this.addressList.length) {
        this.showAddressList = true
      } else {
        this.showAddressList = false
      }
    },
    handleFocusAddress () {
      if (this.addressList.length) {
        this.showAddressList = true
      } else {
        this.showAddressList = false
      }
    },
    handleBlurAddress () {
      setTimeout(() => {
        this.showAddressList = false
      }, 400)
    },
    chooseAddressItem (address) {
      this.formRegisterData.address1 = address
      this.showAddressList = false
    },
    async searchAddressByPostalCode () {
      this.addressList = []
      this.loader = this.$loading.show()
      await DeliveryInfoSellerService.searchAddressByPostalCode({ postalcode: this.formRegisterData.postalCode })
        .then((response) => {
          this.loader && this.loader.hide()
          let results = response.data
          if (results && results.length) {
            this.formRegisterData.address1 = `${results[0]['address1']} ${results[0]['address2']} ${results[0]['address3']}`
            if (results.length === 1) {
              this.showAddressList = false
            } else {
              results.filter((item) => {
                this.addressList.push(`${item['address1']} ${item['address2']} ${item['address3']}`)
                this.showAddressList = true
              })
            }
          }
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    },
    handleSubmit () {
      const hasError = this.validateSubmit()
      if (!hasError) {
        this.$emit('updatedDeliveryInfo', this.formRegisterData)
      }
    },
    validateSubmit () {
      let hasError = false
      this.validateErrors = {
        name: '',
        postalCode: '',
        address1: '',
        address2: '',
        phoneNo: ''
      }
      if (this.isInValidName()) {
        this.validateErrors.name = '※16文字以内でご入力ください'
        hasError = true
      }

      if (this.isInValidPostalCode()) {
        this.validateErrors.postalCode = '※半角数値、またはハイフン（-）で10文字以内でご入力ください'
        hasError = true
      }

      if (!this.formRegisterData.address1 || this.isInValidAdress(this.formRegisterData.address1)) {
        this.validateErrors.address1 = '※400文字以内でご入力ください'
        hasError = true
      }

      if (this.isInValidAdress(this.formRegisterData.address2)) {
        this.validateErrors.address2 = '※400文字以内でご入力ください'
        hasError = true
      }

      if (this.isInValidPhoneNo()) {
        this.validateErrors.phoneNo = '※半角数値、またはハイフン（-）で20文字以内でご入力ください'
        hasError = true
      }

      return hasError
    },
    setFormRegisterData () {
      if (this.deliveryInfo) {
        this.formRegisterData.name = this.deliveryInfo.name
        this.formRegisterData.postalCode = this.deliveryInfo.postalCode
        this.formRegisterData.address1 = this.deliveryInfo.address1
        this.formRegisterData.address2 = this.deliveryInfo.address2
        this.formRegisterData.phoneNo = this.deliveryInfo.phoneNo
      }
    },
    getByteSize (str) {
      return new Blob([str]).size
    },
    handleInputPostalCode (value) {
      return value.replace(/[^0-9-]/g, '')
    },
    handleInputPhoneNo (value) {
      return value.replace(/[^0-9-]/g, '')
    },
    isInValidName () {
      const limitByteSizeName = 48
      const size = this.getByteSize(this.formRegisterData.name)
      return size > limitByteSizeName || size < 1
    },
    isInValidPostalCode () {
      return this.formRegisterData.postalCode.length > 10 || this.formRegisterData.postalCode.length < 1
    },
    isInValidPhoneNo () {
      return this.formRegisterData.phoneNo.length > 20 || this.formRegisterData.phoneNo.length < 1
    },
    isInValidAdress (address) {
      return address.length > 400
    }
  },
  mounted () {
    this.setFormRegisterData()
    $('#register-delivery-info-modal').modal('show')
    $('#register-delivery-info-modal').on('hidden.bs.modal', (e) => {
      if (!$('#delivery-info-modal').length) {
        $('body').attr({
          style: 'padding-right: 0px !important; overflow: unset !important'
        })
      } else {
        $('body').attr('style', 'overflow: hidden !important')
      }
    })
  },
  beforeDestroy () {
    this.loader && this.loader.hide()
    this.$emit('close')
    $('.modal-backdrop').remove()
    setTimeout(() => {
      if (!$('#delivery-info-modal').length) {
        $('body').attr({
          style: null
        })
      } else {
        $('body').attr('style', 'overflow: hidden !important')
      }
    }, 700)
  }
}
</script>
<style scoped>
.label-required {
  background-color: #c00000;
  color: white;
  text-align: center;
  padding: 0 15px;
  border-radius: 4px;
  margin-left: 10px;
}
.label-any {
  background-color: #002060;
  color: white;
  text-align: center;
  padding: 0 15px;
  border-radius: 4px;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/view/warehouseAcross/components/RegisterDeliveryInfoModal.vue